// extracted by mini-css-extract-plugin
export var typingIndicator = "_hh-0";